import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CandidateGroup from './CandidateGroup';
import { ICandidateGroup } from './types';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function CandidateGroupPage({ group }: { group: ICandidateGroup }) {
  return (
    <QueryClientProvider client={queryClient}>
      <CandidateGroup group={group} />
    </QueryClientProvider>
  );
}
